import classNames from 'classnames';

interface MiniSwitchProps {
  className?: string;
  checked: boolean;
  onClick?: () => void;
}

function MiniSwitch({ className, checked, onClick }: MiniSwitchProps) {
  return (
    <div
      className={classNames(
        `relative h-[14px] w-[22px] cursor-pointer rounded-full border-2 border-blue-700`,
        `after:content-[' '] after:absolute after:top-[2px] after:h-[6px] after:w-[6px] after:rounded-full after:border-2`,
        'duration-300 ease-in after:duration-300 after:ease-in',
        !checked && 'bg-white after:left-[3px] after:border-blue-700',
        checked && 'bg-blue-700 after:left-[10px] after:border-white',
        className
      )}
      onClick={onClick}
    />
  );
}

export default MiniSwitch;
